import React, { useEffect, useState } from 'react'
import { Menu, X, Waves } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  const navLinks = [
    // {
    //   name: 'About',
    //   href: '#about',
    // },
    // {
    //   name: 'Technology',
    //   href: '#technology',
    // },
    // {
    //   name: 'Impact',
    //   href: '#impact',
    // },
    // {
    //   name: 'Projects',
    //   href: '#projects',
    // },
    {
      name: 'Contact',
      href: '#contact',
    },
  ]
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <a href="#" className="flex items-center space-x-2 group">
            {/* <div
              className={`p-2 rounded-lg transition-colors ${isScrolled ? 'bg-ocean-900 text-white' : 'bg-white text-ocean-900'}`}
            >
              <Waves className="h-6 w-6" />
            </div> */}
             <img
    src="/logo/enersic-logo.png"
    alt="Enersic"
    className={`h-10 w-auto transition-all ${
      isScrolled ? 'filter-none' : 'brightness-0 invert'
    }`}
  />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:text-ocean-500 ${isScrolled ? 'text-navy-900' : 'text-white/90'}`}
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all transform hover:scale-105 ${isScrolled ? 'bg-ocean-900 text-white hover:bg-ocean-800' : 'bg-white text-ocean-900 hover:bg-ocean-50'}`}
            >
              Partner With Us
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-md ${isScrolled ? 'text-navy-900' : 'text-white'}`}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{
              opacity: 0,
              height: 0,
            }}
            animate={{
              opacity: 1,
              height: 'auto',
            }}
            exit={{
              opacity: 0,
              height: 0,
            }}
            className="md:hidden bg-white border-t border-gray-100"
          >
            <div className="px-4 pt-2 pb-6 space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-3 py-4 text-base font-medium text-navy-900 hover:bg-ocean-50 hover:text-ocean-900 rounded-md"
                >
                  {link.name}
                </a>
              ))}
              <div className="pt-4">
                <a
                  href="#contact"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full text-center px-5 py-3 rounded-md font-semibold bg-ocean-900 text-white hover:bg-ocean-800"
                >
                  Partner With Us
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  )
}
